
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__link","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.23 10.47l-.35.36a.5.5 0 01-.71-.71l.89-.88-.36-.36a.75.75 0 00-1.06 0L2.52 11a.75.75 0 000 1.06l1.41 1.41a.75.75 0 001.06 0l2.13-2.12a.72.72 0 00.21-.57l1-1A2 2 0 018 12.24l-2.12 2.12a2 2 0 01-2.83 0L1.64 13a2 2 0 010-2.83L3.76 8a2 2 0 012.83 0l.35.35 1.41-1.41L8 6.59a2 2 0 010-2.83l2.12-2.12a2 2 0 012.83 0l1.41 1.41a2 2 0 010 2.83L12.24 8a2 2 0 01-2.43.31l1-1a.72.72 0 00.57-.21l2.1-2.1a.75.75 0 000-1.06l-1.41-1.42a.75.75 0 00-1.06 0L8.88 4.64a.75.75 0 000 1.06l.36.36.88-.89a.5.5 0 01.71.71z"}})])
          )
        }
      }
    